import React from 'react';
import './MyBallotsModal.css';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

const MyBallotsModal = ({
    isOpen,
    onClose,
    subBallots,
    isLoading,
    parentTitle
}) => {
    if (!isOpen) return null;

    return (
        <div className="my-ballots-modal-overlay" onClick={onClose}>
            <div
                className="my-ballots-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="my-ballots-modal-header">
                    <div className="header-text">
                        <h3>Follow-up Questions</h3>
                        {parentTitle && <p className="parent-title">Parent: {parentTitle}</p>}
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>

                <div className="my-ballots-modal-body">
                    {isLoading ? (
                        <div className="modal-loader-container">
                            <CircularProgress sx={{ color: '#5AAF9A' }} />
                            <span>Loading follow-up questions...</span>
                        </div>
                    ) : subBallots && subBallots.length > 0 ? (
                        <div className="sub-ballots-list">
                            {subBallots.map((sub, idx) => (
                                <div key={sub.voteId || idx} className="sub-ballot-card">
                                    <h4 className="sub-ballot-q">Q: {sub.title}</h4>
                                    <div className="sub-ballot-options">
                                        {sub.options.map(opt => (
                                            <div key={opt.id} className="sub-opt-row">
                                                <div className="sub-opt-info">
                                                    <span className="sub-opt-val">{opt.value}</span>
                                                    <span className="sub-opt-perc">{Math.round(opt.percentage)}%</span>
                                                </div>
                                                <div className="sub-opt-progress">
                                                    <div
                                                        className="sub-opt-fill"
                                                        style={{ width: `${opt.percentage}%` }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-sub-ballots">
                            No follow-up questions found for this ballot.
                        </div>
                    )}
                </div>

                <div className="my-ballots-modal-footer">
                    <button className="confirm-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MyBallotsModal;
